export const inputClass =
  "w-full px-2 py-2 text-sm rounded-xl border border-gray-300 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-[#229a88] focus:border-transparent shadow-sm transition duration-150 ease-in-out placeholder-gray-400";
export const selectClass = inputClass + " pr-10";
